import React from "react";
import ContactForm from "../common/ContactForm"

const ContactPage = () => {
  return (
    <div>
      <ContactForm />
    </div>
  );
};

export default ContactPage;
